import { render, staticRenderFns } from "./BrightnessLogsListItem.vue?vue&type=template&id=0fc74e44&"
import script from "./BrightnessLogsListItem.vue?vue&type=script&lang=js&"
export * from "./BrightnessLogsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports